import React from 'react';
import { Link } from 'react-router-dom';

function Footer({ onNavigateToUpdates }) {
  return (
    <footer className="footer bg-gray-800 text-white p-4">
      <div className="container mx-auto flex flex-wrap justify-center items-center text-sm gap-x-4 gap-y-2">
        <p>© Copyright phonewallpapers.co.uk 2024</p>
        <span className="mx-2">|</span>

        <Link to="/how-it-works" className="text-blue-500 hover:text-blue-700">How It Works</Link>
        <span className="mx-2">|</span>

        <a
          href="https://us22.list-manage.com/contact-form?u=195827dc2626a774a3aeddc21&form_id=02a09c92175c01fe8426d2b96fb9fcfa"
          className="text-blue-600 hover:text-blue-800 visited:text-purple-600"
          target="_blank" rel="noopener noreferrer"
        >
          Contact Us
        </a>
        <span className="mx-2">|</span>

        <Link to="/phone-cases" className="text-blue-500 hover:text-blue-700">Our Phone Cases</Link>
        <span className="mx-2">|</span>

        <Link to="/free-wallpaper-friday" className="text-pink-400 hover:text-pink-600 font-semibold">
          🎁 Free Wallpaper Friday
        </Link>
        <span className="mx-2">|</span>

        <a
          href="https://www.instagram.com/phonewallpapers.co.uk"
          className="flex items-center text-blue-400 hover:text-pink-500 gap-1"
          target="_blank" rel="noopener noreferrer"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2.2c3.2 0 3.6 0 4.8.1 1.2.1 2 .3 2.4.5.6.3 1.1.7 1.6 1.2.5.5.9 1 1.2 1.6.2.4.4 1.2.5 2.4.1 1.2.1 1.6.1 4.8s0 3.6-.1 4.8c-.1 1.2-.3 2-.5 2.4-.3.6-.7 1.1-1.2 1.6-.5.5-1 .9-1.6 1.2-.4.2-1.2.4-2.4.5-1.2.1-1.6.1-4.8.1s-3.6 0-4.8-.1c-1.2-.1-2-.3-2.4-.5-.6-.3-1.1-.7-1.6-1.2-.5-.5-.9-1-1.2-1.6-.2-.4-.4-1.2-.5-2.4C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.8c.1-1.2.3-2 .5-2.4.3-.6.7-1.1 1.2-1.6.5-.5 1-.9 1.6-1.2.4-.2 1.2-.4 2.4-.5C8.4 2.2 8.8 2.2 12 2.2m0-2.2C8.7 0 8.3 0 7 .1 5.6.2 4.5.5 3.6.9c-.9.4-1.7 1-2.4 1.7C.5 3.3 0 4.1 0 5c-.4.9-.7 2-.8 3.4C-.9 8.3-1 8.7-1 12s.1 3.7.2 4.9c.1 1.3.4 2.4.8 3.4.4.9 1 1.7 1.7 2.4.7.7 1.5 1.3 2.4 1.7.9.4 2 .7 3.4.8 1.2.1 1.6.2 4.9.2s3.7 0 4.9-.2c1.3-.1 2.4-.4 3.4-.8.9-.4 1.7-1 2.4-1.7.7-.7 1.3-1.5 1.7-2.4.4-.9.7-2 .8-3.4.1-1.2.2-1.6.2-4.9s0-3.7-.2-4.9c-.1-1.3-.4-2.4-.8-3.4-.4-.9-1-1.7-1.7-2.4-.7-.7-1.5-1.3-2.4-1.7-.9-.4-2-.7-3.4-.8C15.7.1 15.3 0 12 0zm0 5.8a6.2 6.2 0 1 0 0 12.4 6.2 6.2 0 0 0 0-12.4zm0 10.2a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.4-10.8a1.44 1.44 0 1 0 0 2.88 1.44 1.44 0 0 0 0-2.88z"/>
          </svg>
          Instagram
        </a>

        <span className="mx-2">|</span>

        <a
          href="https://www.facebook.com/share/1GucDmpEtk/?mibextid=wwXIfr"
          className="flex items-center text-blue-400 hover:text-blue-600 gap-1"
          target="_blank" rel="noopener noreferrer"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24">
            <path d="M22.68 0H1.32C.59 0 0 .6 0 1.32v21.36C0 23.4.59 24 1.32 24H12.8v-9.3H9.69V11h3.1V8.39c0-3.07 1.87-4.75 4.6-4.75 1.31 0 2.43.1 2.76.14v3.2h-1.9c-1.49 0-1.78.7-1.78 1.74V11h3.56l-.46 3.7h-3.1V24h6.07c.73 0 1.32-.6 1.32-1.32V1.32C24 .6 23.41 0 22.68 0z"/>
          </svg>
          Facebook
        </a>
      </div>
    </footer>
  );
}

export default Footer;

